
export const setNav = ({ commit }, value) => {
    commit("SET_NAV", value);
};